<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="6"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title float-left pr-1 mb-0">
              Account Requests
            </h1>
          </b-col>
        </b-row>
      </b-col>

      <!-- Content Right -->
      <b-col
        class="content-header-right text-right mb-1"
        cols="6"
      >
        <b-button
          v-if="canViewThisAction('request-user-creation', 'UserCreationRequest')"
          variant="success"
          :to="{ name: 'directory-users-request-create' }"
          class="mobile_create_button"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-50"
            size="16"
          />
          <span class="align-middle d-md-block d-none">Request for New User Account</span>
          <span class="align-middle d-md-none d-block">New Request</span>
        </b-button>
      </b-col>
    </b-row>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            v-if="isMobile()"
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-space_between mb-1 mb-md-0"
          >
            <div
              v-if="canViewThisAction('approve-user-creation', 'UserCreationRequest')"
              class="bulk_selection d-flex"
            >
              <div class="action-left pt-50">
                <b-form-checkbox
                  :checked="selectAllRequestCheckbox"
                  :indeterminate="isSelectAllRequestCheckboxIndeterminate"
                  @change="selectAllCheckboxUpdate"
                >
                  Select All
                </b-form-checkbox>
              </div>
              <b-button
                v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                variant="primary"
                :disabled="!selectedRequests.length"
                @click="bulkApproveRequests"
              >
                Bulk Approve
              </b-button>
            </div>
            <span class="text-muted">Showing <br>{{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span>
          </b-col>
          <b-col
            v-else
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <template v-if="canViewThisAction('approve-user-creation', 'UserCreationRequest')">
              <div class="action-left pt-50">
                <b-form-checkbox
                  :checked="selectAllRequestCheckbox"
                  :indeterminate="isSelectAllRequestCheckboxIndeterminate"
                  @change="selectAllCheckboxUpdate"
                >
                  Select All
                </b-form-checkbox>
              </div>
              <b-button
                v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                variant="primary"
                class="mx-50"
                :disabled="!selectedRequests.length"
                @click="bulkApproveRequests"
              >
                Bulk Approve
              </b-button>
            </template>
            <span class="text-muted">Showing {{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-search"
                @click="showSearchBar = !showSearchBar"
              >
                <feather-icon
                  icon="SearchIcon"
                  size="21"
                  class="mr-50"
                />
                <span class="align-middle">Search</span>
              </a>

              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Search..."
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="searchQuery = ''; showSearchBar = !showSearchBar"
                  />
                </b-input-group-append>
              </b-input-group>

              <b-dropdown
                id="dropdown-block-out-form"
                ref="filter_dropdown_user_request"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="dropdown-modal"
                right
                variant="link"
              >
                <template #button-content>
                  <feather-icon
                    icon="FilterIcon"
                    size="21"
                    class="align-middle mr-50"
                  />
                  <span class="mr-1">Filters</span>
                </template>
                <request-filters
                  :status-filter.sync="statusFilter"
                  :created-by-filter.sync="createdByFilter"
                  :created-at-filter.sync="createdAtFilter"
                  :status-options="statusOptions"
                  :user-options="userOptions"
                  @emitHideFilter="hideFilter"
                  @emitShowFilter="showFilter"
                />
              </b-dropdown>
            </div>
          </b-col>
        </b-row>

        <div v-if="createdByFilter.length || createdAtFilter || statusFilter.length">
          <hr class="dividerHR filter-divider">
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <ul
                class="list-inline d-inline-block mb-1"
              >
                <li
                  v-for="userVal in createdByFilter"
                  :key="userVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromCreatedByFilter(userVal)"
                  >
                    <span class="text-capitalize">{{ resolveCreatorName(userVal) }}</span>
                  </b-form-tag>
                </li>

                <li
                  v-for="statusVal in statusFilter"
                  :key="statusVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromStatusFilter(statusVal)"
                  >
                    <span class="text-capitalize">{{ resolveStatusName(statusVal) }}</span>
                  </b-form-tag>
                </li>

                <li
                  v-if="createdAtFilter"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="createdAtFilter = null"
                  >
                    <span class="text-capitalize">{{ createdAtFilter }}</span>
                  </b-form-tag>
                </li>
                <li
                  class="list-inline-item"
                >
                  <span
                    class="text-danger clear-filter-text mb-50"
                    @click="clearAllFilters"
                  >
                    Clear Filters
                  </span>
                </li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-table
        ref="refUserRequestsTable"
        class="position-relative min-height-150 td-align-top"
        :items="requestData"
        responsive
        :fields="tableColumns"
        primary-key="_id"
        :sort-by.sync="sortBy"
        show-empty
        no-sort-reset
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(stringID)="data">
          <div
            v-if="canViewThisAction('approve-user-creation', 'UserCreationRequest')"
            class="text-nowrap"
          >
            <b-form-checkbox
              :checked="selectedRequests.includes(data.item._id)"
              :disabled="data.item.status != 'awaiting approval'"
              @change="toggleSelectedRequests(data.item._id)"
              @click.native.stop
            >
              <b-button
                v-if="canViewThisAction('user-creation-show', 'UserCreationRequest')"
                v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                variant="link"
                class="weight-600 align-middle detail-view-id"
                :to="{ name: 'directory-users-request-show', params: { id: data.item._id } }"
              >
                {{ data.item.stringID }}
              </b-button>
              <b-button
                v-else
                v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                variant="none"
                class="text-bold-black align-middle detail-view-id not-button"
              >
                {{ data.item.stringID }}
              </b-button>
            </b-form-checkbox>
          </div>
          <div
            v-else
            class="text-nowrap"
          >
            <b-button
              v-if="canViewThisAction('user-creation-show', 'UserCreationRequest')"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id"
              :to="{ name: 'directory-users-request-show', params: { id: data.item._id } }"
            >
              {{ data.item.stringID }}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="none"
              class="text-bold-black align-middle detail-view-id not-button"
            >
              {{ data.item.stringID }}
            </b-button>
          </div>
        </template>

        <template #cell(detail)="data">
          <div class="">
            <b-table-simple
              borderless
              responsive
              class="particulars_of_deceased no-padding-table"
            >
              <b-tbody>
                <b-tr>
                  <b-td width="45px">
                    <b-avatar
                      text="N"
                      variant="light-primary"
                    />
                  </b-td>
                  <b-td>
                    <span class="">{{ data.item.name || '-' }}</span>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td width="45px">
                    <b-avatar
                      text="P"
                      variant="light-primary"
                    />
                  </b-td>
                  <b-td>
                    <span class="">{{ data.item.position || '-' }}</span>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td width="45px">
                    <b-avatar
                      text="D"
                      variant="light-primary"
                    />
                  </b-td>
                  <b-td>
                    <span
                      v-for="(department, key) in data.item.department"
                      :key="key"
                    >
                      {{ department.name }}<span v-if="key < data.item.department.length - 1">, </span>
                    </span>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td width="45px">
                    <b-avatar
                      text="E"
                      variant="light-primary"
                    />
                  </b-td>
                  <b-td>
                    <span class="">{{ data.item.email || '-' }}</span>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td width="45px">
                    <b-avatar
                      text="R"
                      variant="light-primary"
                    />
                  </b-td>
                  <b-td>
                    <div class="d-flex flex-wrap gap-1">
                      <b-badge
                        v-for="(role, key) in data.item.roles"
                        :key="key"
                        variant="outline-primary"
                      >
                        {{ role.role }}
                      </b-badge>
                    </div>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </template>

        <template #cell(createdBy)="data">
          <div class="">
            <!-- <span class="">{{ data.item.createdBy.name }}</span> -->
            <b-button
              v-if="canViewThisAction('show', 'User')"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id"
              :to="{ name: 'directory-users-show', params: { id: data.item.createdBy._id } }"
            >
              {{ data.item.createdBy.name }}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="none"
              class="text-bold-black align-middle detail-view-id not-button"
            >
              {{ data.item.createdBy.name }}
            </b-button>
            <br>
            <span class="">{{ data.item.createdBy.position }}</span>
            <br>
            <span
              v-for="(department, key) in data.item.createdBy.department"
              :key="key"
            >
              {{ department.name }}<span v-if="key < data.item.createdBy.department.length - 1">, </span>
            </span>
          </div>
        </template>

        <template #cell(createdAt)="data">
          <div class="text-nowrap">
            <span class="">{{ dateFormatWithTime(data.item.createdAt) }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            :variant="`light-${resolveRequestStatusVariant(data.item.status)}`"
            class="text-capitalize"
          >
            {{ data.item.status }}
          </b-badge>
          <template v-if="data.item.status == 'rejected' || data.item.status == 'action required'">
            <br>
            <br>
            <span class="text-muted">“{{ data.item.adminRemarks }}”</span>
          </template>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canViewThisAction('user-creation-show', 'UserCreationRequest') || canViewThisAction('approve-user-creation', 'UserCreationRequest')"
          #cell(actions)="data"
        >
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="canViewThisAction('user-creation-show', 'UserCreationRequest')"
              :to="{ name: 'directory-users-request-show', params: { id: data.item._id } }"
            >
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('request-user-creation', 'UserCreationRequest') && data.item.status == 'action required' && data.item.createdBy._id == $store.state.auth.userData._id"
              :to="{ name: 'directory-users-request-edit', params: { id: data.item._id } }"
            >
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('approve-user-creation', 'UserCreationRequest') && data.item.status == 'awaiting approval'"
              @click="approveRequest(data.item._id)"
            >
              <span class="align-middle ml-50">Approve</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('approve-user-creation', 'UserCreationRequest') && data.item.status == 'awaiting approval'"
              @click="rejectRequest(data.item._id, data.item.stringID, data.item.createdBy)"
            >
              <span class="align-middle ml-50">Reject</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
    </b-card>

    <div
      v-if="totalRequests > perPage"
      class="mx-2 mb-2"
    >
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center pagination-content"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalRequests"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            align="center"
            prev-text="Prev"
            next-text="Next"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
              <span>Prev</span>
            </template>
            <template #next-text>
              <span>Next</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BCard, BRow, BButton, BCol, BFormInput, BTable, BInputGroup, BInputGroupAppend, BAvatar, BFormCheckbox,
  BBadge, BDropdown, BDropdownItem, BPagination, BFormTag, BTableSimple, BTbody, BTr, BTd,
} from 'bootstrap-vue'
import { ref, onUnmounted, computed } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import useRequestsList from './useRequestsList'
import requestStoreModule from './requestStoreModule'
import RequestFilters from './RequestFilters.vue'
// import UserListAddNew from './UserListAddNew.vue'

export default {
  components: {
    // UserListAddNew,
    BFormTag,
    BCard,
    BRow,
    BButton,
    BCol,
    BFormInput,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BTableSimple,
    BTbody,
    BTr,
    BTd,
    BAvatar,
    BFormCheckbox,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,

    RequestFilters,
  },
  directives: {
    Ripple,
  },
  props: {
    roleId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      userOptions: [],
      statusOptions: [
        { text: 'Approved', value: 'approved' },
        { text: 'Rejected', value: 'rejected' },
        { text: 'Action Required', value: 'action required' },
        { text: 'Awaiting Approval', value: 'awaiting approval' },
      ],
    }
  },

  beforeMount() {
    this.$http.get('directory/users/activity-log/respond-with/extra-options')
      .then(response => {
        this.userOptions = response.data.userOptions ?? []
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },

  methods: {
    hideFilter() {
      this.$refs.filter_dropdown_user_request.hide(true)
    },
    showFilter() {
      this.$refs.filter_dropdown_user_request.show(true)
    },
    removeFromCreatedByFilter(item) {
      const index = this.createdByFilter.indexOf(item)
      if (index > -1) {
        this.createdByFilter.splice(index, 1)
      }
    },
    removeFromStatusFilter(item) {
      const index = this.statusFilter.indexOf(item)
      if (index > -1) {
        this.statusFilter.splice(index, 1)
      }
    },

    clearAllFilters() {
      this.createdAtFilter = ''
      this.createdByFilter = []
      this.statusFilter = []
    },
    resolveCreatorName(id) {
      const user = this.userOptions.find(o => o._id === id)
      if (user) {
        return user.name || ''
      }
      return ''
    },
    resolveStatusName(id) {
      const status = this.statusOptions.find(o => o.value === id)
      if (status) {
        return status.text || ''
      }
      return ''
    },
    approveRequest(id) {
      this.$swal({
        title: 'Approve this User Request?',
        html: '<br>You are going to approve this User Request. Are you sure?',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/success.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'No, go back',
        confirmButtonText: 'Yes, proceed',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            const formData = new FormData()
            formData.append('url', window.location.origin)

            this.$http.post(`directory/users/requests/${id}/approve`, formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            })
              .then(() => {
                this.fetchRequests()
                this.$swal({
                  title: 'Request approved',
                  html: '',
                  // eslint-disable-next-line global-require
                  imageUrl: require('@/assets/images/icons/success.png'),
                  imageWidth: 80,
                  imageHeight: 80,
                  imageAlt: 'Custom Icon',
                  showCancelButton: false,
                  confirmButtonText: 'Okay',
                  customClass: {
                    confirmButton: 'btn btn-primary mt-1',
                  },
                  buttonsStyling: false,
                })
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          }
        })
    },

    rejectRequest(id, stringID, createdBy) {
      this.$swal({
        title: 'Are you sure you want to reject this request?',
        html: `<br>Once you reject this request <strong>${stringID}, <br> ${createdBy.name}</strong> will be informed.`,
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/file-cross.png'),
        input: 'textarea',
        inputPlaceholder: 'Add Remarks',
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Yes, reject request',
        cancelButtonText: 'No, go back',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
          input: 'reject-note-ta',
        },
        buttonsStyling: false,
        preConfirm: inputValue => {
          const textarea = this.$swal.getInput()
          const errorContainer = document.getElementById('swal-validation-error')

          if (!inputValue || inputValue.trim() === '') {
            textarea.classList.add('swal-input-error')
            if (!errorContainer) {
              const errorEl = document.createElement('small')
              errorEl.id = 'swal-validation-error'
              errorEl.innerText = 'Remarks are required to reject the request.'
              textarea.parentNode.appendChild(errorEl)
            }
            return false
          }

          // Cleanup if valid
          textarea.classList.remove('swal-input-error')
          if (errorContainer) errorContainer.remove()

          return inputValue
        },
        didOpen: () => {
          const textarea = this.$swal.getInput()
          textarea.classList.remove('swal-input-error')
        },
      })
        .then(result => {
          if (result.value) {
            const formData = new FormData()
            formData.append('remarks', result.value)
            formData.append('url', window.location.origin)

            this.$http.post(`directory/users/requests/${id}/reject`, formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            })
              .then(() => {
                this.fetchRequests()
                this.$swal({
                  title: 'Request rejected',
                  html: '',
                  // eslint-disable-next-line global-require
                  imageUrl: require('@/assets/images/icons/success.png'),
                  imageWidth: 80,
                  imageHeight: 80,
                  imageAlt: 'Custom Icon',
                  showCancelButton: false,
                  confirmButtonText: 'Okay',
                  customClass: {
                    confirmButton: 'btn btn-primary mt-1',
                  },
                  buttonsStyling: false,
                })
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          } else if (result.dismiss !== 'cancel') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Please provide your remarks',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
    },
    bulkApproveRequests() {
      this.$swal({
        title: 'Approve these User Requests?',
        html: 'You are going to approve these User Requests. Are you sure?',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/success.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Yes, proceed!',
        cancelButtonText: 'No, go back',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            const formData = new FormData()
            formData.append('status', 'approved')
            formData.append('url', window.location.origin)
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < this.selectedRequests.length; i++) {
              formData.append('requests[]', this.selectedRequests[i])
            }

            this.$http.post('directory/users/requests/approve/bulk', formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            })
              .then(() => {
                this.selectedRequests = []
                this.fetchRequests()
                this.$swal({
                  title: 'Requests approved',
                  html: '',
                  // eslint-disable-next-line global-require
                  imageUrl: require('@/assets/images/icons/success.png'),
                  imageWidth: 80,
                  imageHeight: 80,
                  imageAlt: 'Custom Icon',
                  showCancelButton: false,
                  confirmButtonText: 'Okay',
                  customClass: {
                    confirmButton: 'btn btn-primary mt-1',
                  },
                  buttonsStyling: false,
                })
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          }
        })
    },
  },
  setup() {
    const showSearchBar = ref(false)
    const showFilterOptions = ref(false)
    const USER_REQUEST_APP_STORE_MODULE_NAME = 'app-user-requests'

    // console.log(props.roleId)

    // Register module
    if (!store.hasModule(USER_REQUEST_APP_STORE_MODULE_NAME)) store.registerModule(USER_REQUEST_APP_STORE_MODULE_NAME, requestStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_REQUEST_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_REQUEST_APP_STORE_MODULE_NAME)
    })

    const { canViewThisAction } = useAclUtils()

    const {
      requestData,
      fetchRequests,
      tableColumns,
      perPage,
      currentPage,
      totalRequests,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserRequestsTable,
      refetchData,

      currentDataLength,

      // UI
      resolveRequestStatusVariant,

      // Extra Filters
      statusFilter,
      createdAtFilter,
      createdByFilter,
    } = useRequestsList()

    const selectedRequests = ref([])
    const toggleSelectedRequests = requestId => {
      const requestIndex = selectedRequests.value.indexOf(requestId)

      if (requestIndex === -1) selectedRequests.value.push(requestId)
      else selectedRequests.value.splice(requestIndex, 1)
    }
    const selectAllRequestCheckbox = computed(() => requestData.value.length && (requestData.value.length === selectedRequests.value.length))
    const isSelectAllRequestCheckboxIndeterminate = computed(() => Boolean(selectedRequests.value.length) && requestData.value.length !== selectedRequests.value.length)
    const selectAllCheckboxUpdate = val => {
      if (val) {
        selectedRequests.value = requestData.value.filter(r => r.status === 'awaiting approval').map(flow => flow._id)
      } else {
        selectedRequests.value = []
      }
      // selectedRequests.value = val ? requestData.value.map(flow => flow._id) : []
    }

    return {
      requestData,
      fetchRequests,
      tableColumns,
      perPage,
      currentPage,
      totalRequests,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserRequestsTable,
      refetchData,
      showSearchBar,
      showFilterOptions,
      currentDataLength,

      // Filter
      avatarText,

      // UI
      resolveRequestStatusVariant,

      canViewThisAction,

      // Extra Filters
      statusFilter,
      createdAtFilter,
      createdByFilter,

      selectAllRequestCheckbox,
      isSelectAllRequestCheckboxIndeterminate,
      selectedRequests,
      toggleSelectedRequests,
      selectAllCheckboxUpdate,
    }
  },
}
</script>

<style lang="scss">
.per-page-selector {
  width: 90px;
}
.badge-outline-primary {
  border: 1px solid #D2DCEA;
  background-color: #FFF;
  color: #333333;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
}
.td-align-top .table td {
  vertical-align: top;
}
.td-align-top .particulars_of_deceased .table td {
  vertical-align: middle;
}
.gap-1 {
  gap: 5px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
